<template>
	<div id="DomainsList" class="text-left menu-component">
		<h4>Domínios</h4>

		<div class="total-domains" v-if="!loadingDomains">
			<div v-if="errorLoadDomains" class="text-center">
				<p class="pl-3 mb-3">{{ errorMessage }}</p>
				<button class="btn btn-primario" @click="getDomains">Tentar novamente</button>
			</div>

			<label>{{checkActive}}</label>

			<div class="item-domains mt-2" v-for="active in filterAdctiveDomains" :key="active.id">
                <domainCard
                    :domain="active"
                    @confirmDelete="handleRemove"
                    @saveEdit="saveEditDomain"
                    :errorMsgDomain='active.id == updatingDomain ? errorMsgDomain : ""'
                />
			</div>

			<label class="mt-4" v-if="filterInactiveDomains.length > 0">Endereços secundários</label>

			<div class="item-domains mt-2" v-for="inactive in filterInactiveDomains" :key="inactive.id">
                <domainCard
                    :domain="inactive"
                    @confirmDelete="handleRemove"
                    @favoriteDomain="handleFavorite"
                    @saveEdit="saveEditDomain"
					:errorMsgDomain='inactive.id == updatingDomain ? errorMsgDomain : ""'
                />
			</div>

			<div class="text-center mt-4">
				<button
					type="button"
					class="btn btn-small btn-primario"
					@click="addDomainModal = true"
				>Adicionar domínio</button>
			</div>

			<label class="mt-4">
				Para adicionar endereço .com.br .com ou outros, siga as instruções
				abaixo:
			</label>

			<div class="tutorial-integracao mt-3 mb-2 mx--4">
				<hr class="m-0" />

				<div class="px-4 py-3">
					<p v-b-toggle.configRegistroBr class="toggle--tutorial m-0">
						<span>
							<strong>Configurar domínio no Registro.br</strong>
						</span>
						<span class="float-right">
							<i class="fal fa-chevron-down"></i>
						</span>
					</p>
					<b-collapse id="configRegistroBr" accordion="infoDomains" class="mt-2 tutorial--text">
						<p class="pt-2">
							Se você ainda não registrou um domínio, registre pelo site
							<a
								href="http://www.registro.br"
								target="_blank"
								rel="noopener noreferrer"
							>
								<strong>www.registro.br</strong>
							</a>
                            <br />
							<br />Se já tem domínio registrado, siga os passos abaixo:
                            <br>
                            <ol>
                                <li>Acesse sua conta em
                                    <a
								        href="http://www.registro.br"
								        target="_blank"
								        rel="noopener noreferrer"
							        >
								    <strong>www.registro.br</strong>
							        </a>
                                </li>
                                <br>
                                <li>Clique no seu domínio</li>
                                <br>
                                <li>
                                    Em DNS clique em
                                    <strong>» EDITAR ZONA (Configurar Endereçamento)</strong> e <strong>> Modo Avançado</strong><br>
                                    <i>Aguarde cerca de 5 minutos e acesse novamente para aparecer opções.</i>
                                </li>
                                <br>
                                <li>
                                    Clique em
                                    <strong>NOVA ENTRADA</strong> e adicione
                                    as informações abaixo:
                                    <ul>
                                        <li>Primeiro campo deixe vazio</li>
                                        <li>Selecione Tipo <strong>A</strong></li>
                                        <li>Endereço IP: <strong>18.229.165.166</strong> <br></li>
                                        <li>Clique <strong>Adicionar</strong></li>
                                        <br>
                                    </ul>
                                </li>
                                <li>Novamente clique em <strong>NOVA ENTRADA</strong> e adicione as informações abaixo:
                                    <ul>
                                        <li>Primeiro campo deixe: <strong>www</strong></li>
                                        <li>Selecione tipo <strong>CNAME</strong></li>
                                        <li>Nome do servidor: <strong>seudominio.com.br</strong></li>
                                        <li>Clique <strong>Adicionar</strong></li>
                                    </ul>
                                </li>
                            </ol>
						</p>
						<img src="@/assets/img/faq/dominio-zona-dns-registro-br@2x.png" class="img-fluid mb-2" alt />
						<p>
							*seudominio significa o domínio que você registrou.
							<br />Clique em
							<strong>SALVAR</strong>
						</p>
						<p class="text-center">
							Depois, adicione seu domínio clicando no botão abaixo:
							<br />
							<button
								type="button"
								class="btn btn-small btn-primario mt-2"
								@click="addDomainModal = true"
							>Adicionar domínio</button>
						</p>
						<p>
							Se não conseguir seguindo os passos acima, tente direto no
							servidor que registrou o domínio (dicas abaixo), entre em contato
							com a gente: (17) 98163-0625 pelo email: epics@epics.com.br ou
							veja esse
							<a
								href="https://uli.zendesk.com/hc/pt-br/articles/360033941314-Como-apontar-meu-dom%C3%ADnio-para-um-site-Uli"
								target="_blank"
								rel="noopener noreferrer"
							>
								<strong>Tutorial</strong>
							</a>
						</p>
					</b-collapse>
				</div>
				<hr class="m-0" />

				<div class="px-4 py-3">
					<p v-b-toggle.configOthers class="toggle--tutorial m-0">
						<span>
							<strong>Configurar domínio no GoDaddy</strong>
						</span>
						<span class="float-right">
							<i class="fal fa-chevron-down"></i>
						</span>
					</p>
					<b-collapse id="configOthers" accordion="infoDomains" class="tutorial--text mt-2">
						<p class="pt-2">
							Clique no seu domínio > Gerenciar > Gerenciar DNS > Adicionar >
							insira as informações abaixo:
						</p>
						<p class="mb-1">Selecione Tipo “A”</p>
						<p class="mb-1">
							<strong>Host:</strong> @
						</p>
						<p class="mb-1">
							<strong>Aponta para:</strong> 18.229.165.166
						</p>
						<p class="mb-1">
							<strong>TTL:</strong> 1 hora
						</p>
						<p class="mb-1">Adicione Nova entrada > Tipo "CNAME"</p>
						<p class="mb-1">
							<strong>Valor:</strong> www
						</p>
						<p class="mb-1">
							<strong>Caminho:</strong> seudominio.com.br
						</p>
						<p>*substitua "seudominio.com.br" pelo seu endereço personalizado</p>
						<p class="text-center">
							Depois, adicione seu domínio clicando no botão abaixo:
							<br />
							<button
								type="button"
								class="btn btn-small btn-primario mt-2"
								@click="addDomainModal = true"
							>Adicionar domínio</button>
						</p>
					</b-collapse>
				</div>
			</div>
		</div>

		<div v-else>
			<div class="row">
				<div class="col text-center">
					<div class="spinner-grow" role="status">
						<span class="sr-only">Loading...</span>
					</div>
				</div>
			</div>
		</div>

		<b-modal
			id="addDomainModal"
			v-model="addDomainModal"
			:title="modalTitle"
			@hidden="resetModal"
			hide-footer
			centered
		>
			<div class="row text-center justify-content-around">
				<!-- Input nome do domínio -->
				<div class="col-12 mb-4" v-if="!verifyDomains && domainRequest == 0">
					<input
						class="form-control default_input"
						type="text"
						placeholder="seudominio.com"
						v-model="newDomain"
						@keyup="verifyDomain"
					/>
					<span v-html="errorMessage" class="error-text"></span>
				</div>

				<!-- Loading da requisição -->
				<div class="col-12 mb-4" v-else-if="domainRequest == 0">
					<p class="text-center load-spinner">
						<i class="fas fa-spinner fa-spin"></i>
					</p>
				</div>

				<!-- Mensagem de sucesso após adição -->
				<div class="col-12 mb-4" v-else-if="domainRequest == 1">
					<p>
						A propagação do domínio pode demorar cerca de 24 horas.
						<a
							class="link-domain"
							:href="zendeskUrl"
							target="_blank"
						>Saiba mais</a>.
					</p>

					<div class="col-12">
						<div class="row text-center justify-content-center my-2">
							<div class="col-4">
								<button class="btn btn-block btn-secundario" @click="dismissModal()">Ok</button>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 tutorial-link text-left" v-if="domainRequest == 0">
					<p class="mb-1">
						<strong>Ainda não registrou?</strong>
					</p>
					<p class="mb-1">
						Compre seu domínio .com.br em
						<a href="https://registro.br/" target="_blank">www.registro.br</a>
					</p>
					<p class="mb-1">
						<strong>Já registrou?</strong>
					</p>
					<p class="mb-1">
						Acesse sua conta onde registrou (registro.br, Godaddy, etc) e
						adicione em DNS nosso IP: 18.229.165.166
					</p>
					<p class="mb-1">
						Dúvidas?
						<strong>
							<a :href="zendeskUrl" target="_blank">Confira esse Tutorial</a>
						</strong>
					</p>
				</div>
				<div class="col-12 my-2" v-if="!verifyDomains && domainRequest == 0">
					<div class="row text-center justify-content-center">
						<div class="col-4">
							<button class="btn btn-block btn-secundario py-3" @click="addDomainModal = false">Cancelar</button>
						</div>
						<div class="col-4">
							<button :disabled="btnToSave" class="btn btn-block btn-primario py-3" @click="validateDomainToSave">Salvar</button>
						</div>
					</div>
				</div>
			</div>
		</b-modal>

		<alertScreen
			:showAlertScreen="showAlert"
			:alertTitle="alertTitle"
			:alertText="alertText"
			@returnAlertScreen="removeDomain($event)"
		/>
		<alertScreen
			:showAlertScreen="showAlertFavorite"
			:alertTitle="alertTitle"
			:alertText="alertText"
			@returnAlertScreen="favoriteDomain($event)"
		/>
	</div>
</template>

<script>
import axios from "axios";
import alertScreen from "../molecules/AlertScreen";
import domainCard from "../molecules/DomainCard";

export default {
	name: "DomainsList",
	data() {
		return {
			updatingDomain: null,
			domainIdDelete: null,
			domainIdFavorite: null,
			alertTitle:null,
      		alertText: null,
      		ROOT_API: null,
			showAlert: false,
			showAlertFavorite: false,
			loadingDomains: false,
			addDomainModal: false,
			newDomain: "",
			errorMessage: "",
            errorMsgDomain: "",
			errorLoadDomains: true,
			listDomains: [],
			domainIdToRemove: null,
			verifyDomains: false,
			domainRequest: 0,
			modalTitle: "Novo domínio",
			btnToSave:false,
			zendeskUrl:
				"https://uli.zendesk.com/hc/pt-br/articles/360033941314-Como-apontar-meu-dom%C3%ADnio-para-um-site-Uli",
		};
	},
	components: {
		alertScreen,
		domainCard
	},
	methods: {
		getDomains,
		addDomain,
		resetModal,
		handleRemove,
		removeDomain,
		changeMainDomain,
		dismissModal,
		getListDomainsStatus,
		getDomainStatus,
		validateDomainToSave() {
			this.errorMessage = "";
			this.addDomain();
		},
		saveEditDomain(domainId, updatedDomain) {
			let siteId = this.$session.get("siteId");
			let token = this.$session.get("jwt");
			let postData = {domain: updatedDomain};
			this.errorMsgDomain = "";
			this.updatingDomain = domainId;

			axios({
				method: "post",
				url: `${this.ROOT_API}api/site/${siteId}/domain/${domainId}/update` ,
				data: postData,
				headers: {
					Authorization: "Bearer " + token,
					"Content-Type": "application/json",
				},
        	}).then((response) => {
            	if (!response.data.success) {
                	this.errorMsgDomain = response.data.message;
            	} else {
					this.getDomains();
				}
        	})
        	.catch(function () {
            	alert("Erro ao editar o domínio, tente novamente.");
        	});
		},
		handleFavorite(domainId) {
			this.domainIdFavorite = domainId;
			this.showAlertFavorite = true;
			for (let i = 0; i < this.listDomains.length; i++) {
				if (this.listDomains[i].id == domainId) {
					this.alertTitle = "Favoritar domínio"
					this.alertText = `Deseja definir o domínio <b>${this.listDomains[i].domain}</b>, como principal ?`
				}
			}
		},
		favoriteDomain(event) {
			let domainId = this.domainIdFavorite
			this.showAlertFavorite = false;
			if (event == 1) {
				let siteId = this.$session.get("siteId");
				let token = this.$session.get("jwt");
				let postData = {
					domain: domainId,
				};
				axios({
					method: "post",
					url:
						`${this.ROOT_API}api/site/${siteId}/domain/${domainId}/main`,
					data: postData,
					headers: {
						Authorization: "Bearer " + token,
						"Content-Type": "application/json",
					},
				})
					.then(() => {
						this.getDomains();
					})
					.catch(function () {
						alert("Erro ao favoritar o domínio, tente novamente.");
					});
			}
		},
		checkWwwDomain(domain) {
			return domain.toLowerCase().match(/www/g);
		},
		checkHttpsDomain(domain) {
			return domain.toLowerCase().match(/http/g);
		},
		verifyDomain() {
			this.btnToSave = false
			this.errorMessage = ""
			if (this.newDomain.includes('epics.vc') || this.newDomain.includes('ulisite.com')) {
				this.btnToSave = true
				this.errorMessage = `Domínio <b style='color:#f00'>epics.vc</b> e
				<b style='color:#f00'>ulisite.com</b> não são permitidos.`
			}
		}
	},
	created() {
		this.getDomains();
    	this.ROOT_API = process.env.ROOT_API;
	},
	computed: {
		checkActive() {
			const active = this.filterAdctiveDomains[0];
			if (active.automatic == 1) {
				return `Endereço temporário`;
			} else {
				return `Endereço principal`;
			}
		},
		filterAdctiveDomains() {
			return this.listDomains.filter((domain) => domain.main_domain == 1);
		},
		filterInactiveDomains() {
			return this.listDomains.filter((domain) => domain.main_domain == 0);
		},
	},
	props: {
		saveData: {
			type: Boolean,
			required: true,
		},
		siteId: {
			type: Number,
			required: true,
		},
	},
};
function dismissModal() {
	this.addDomainModal = false;
	this.domainRequest = 0;
	this.modalTitle = "Novo domínio";
}
function resetModal() {
	this.errorMessage = "";
	this.newDomain = "";
}
function getDomains() {
	this.loadingDomains = true;
	this.errorLoadDomains = false;
	this.listDomains = [];
	let api = process.env.ROOT_API;
	let token = this.$session.get("jwt");
	axios({
		method: "get",
		url: api + "api/site/" + this.siteId + "/domain",
		data: "",
		headers: {
			Authorization: "Bearer " + token,
			// 'Content-Type': 'application/x-www-form-urlencoded'
		},
	})
	.then((response) => {
		this.listDomains = response.data.data;
		this.loadingDomains = false;
	})
	.catch((response) => {
		this.loadingDomains = false;
		this.errorMessage = "Não foi possível recuperar os domínios.";
		this.errorLoadDomains = true;
	})
	.finally((response) => {
		this.getListDomainsStatus();
	});
}
function getListDomainsStatus() {
	for (let index = 0; index < this.listDomains.length; index++) {
		let item = this.listDomains[index];
		if (item.automatic != 1) this.getDomainStatus(item.id, index);
	}
}
function getDomainStatus(id, index){
	let api = process.env.ROOT_API;
	let token = this.$session.get("jwt");

	axios({
		method: "get",
		url: api + "api/site/" + this.siteId + "/domain/" + id + "/dns",
		headers: {
			Authorization: "Bearer " + token,
		},
	})
	.then((response) => {
		if(response.data.status == '1'){
			this.listDomains[index].status = response.data.data;
		}
	})
	.catch((response) =>{
		this.listDomains[index].status = 'offline';
	});

}
function addDomain() {
	this.errorMessage = "";
	if (this.newDomain.length > 6) {
		this.verifyDomains = true;
		let token = this.$session.get("jwt");
		let totalData = new FormData();
		totalData.append("url", this.newDomain);
		totalData.append("main", 0);
		axios({
			method: "post",
			url: `${process.env.ROOT_API}api/site/${this.siteId}/domain/create`,
			data: totalData,
			headers: {
				Authorization: "Bearer " + token,
				// 'Content-Type': 'application/x-www-form-urlencoded'
			},
		})
			.then((response) => {
				//handle success
				if (response.data.status == 1) {
					this.listDomains.push(response.data.data);
					this.domainRequest = 1;
					this.modalTitle = "Domínio adicionado com sucesso";
				} else if (response.data.status == 0) {
					this.errorMessage = response.data.error;
				}
				this.getDomains();
			})
			.catch((response) => {
				//handle error
			})
			.finally(() => {
				this.verifyDomains = false;
			});
	} else {
		this.errorMessage = "Domínio curto";
	}
}
function handleRemove(domainId) {
  this.domainIdDelete = domainId
  this.showAlert = true;
  for (let i = 0; i < this.listDomains.length; i++) {
    if (this.listDomains[i].id == domainId) {
			this.alertTitle = "Excluir domínio"
      this.alertText = `Você está removendo o domínio <b>${this.listDomains[i].domain}</b>, tem certeza que deseja continuar?`
    }
  }

}
function removeDomain(event) {
	this.showAlert = false;
	this.loadingDomains = true;
	let remove = event;
	let domainId = this.domainIdDelete;
	if (remove == 1) {
		let token = this.$session.get("jwt");
		let siteId = this.$session.get("siteId");
		let totalData = "";

		axios({
			method: "post",
			url:
			`${this.ROOT_API}api/site/${siteId}/domain/${domainId}/delete` ,
			data: totalData,
			headers: {
			Authorization: "Bearer " + token,
			"Content-Type": "application/x-www-form-urlencoded",
			},
		})
		.then((response) => {
			if (response.data.status == 1) {
				this.getDomains();
			}
		})
		.catch(function () {
			alert("Erro ao deletar dominio, tente novamente.");
		});
	}
}
function changeMainDomain(domainId, domainName) {
	for (let i = 0; i < this.listDomains.length; i++) {
		if (this.listDomains[i].id != domainId) {
			this.listDomains[i].main_domain = 0;
		} else {
			this.listDomains[i].main_domain = 1;
		}
	}
	this.loadingDomains = true;
	let token = this.$session.get("jwt");
	let totalData = {
		listDomains: this.listDomains,
	};
	axios({
		method: "post",
		url:
			process.env.ROOT_API +
			"api/site/" +
			this.siteId +
			"/domain/massupdate",
		data: totalData,
		headers: {
			Authorization: "Bearer " + token,
			// 'Content-Type': 'application/x-www-form-urlencoded'
		},
	})
		.then((response) => {
			//handle success
			if (response.data.status == 1) {
				this.$emit("updateDomain", domainName);
			}
		})
		.catch((response) => {
			//handle error
			// this.errorMessage = "Não foi possível recuperar os domínios."
			// this.getDomains();
		})
		.finally(() => {
			this.getDomains();
		});
}
</script>

<style>
.error-text {
	color: #f00;
	font-size: 12px;
}
</style>

<style scoped>
.tutorial--text {
	font-size: 0.62rem;
	color: #777777;
}
.tutorial--text a {
	color: #777777;
}
.tutorial--text a:hover {
	text-decoration: none;
}
.toggle--tutorial {
	cursor: pointer;
}
.total-domains label {
	font-size: 0.62rem;
}
.item-domains {
	border: none;
}
.item-domains p {
	margin-bottom: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.clickable:hover,
.remove-domain:hover {
	cursor: pointer;
}
.remove-domain {
	color: #777777;
}
.load-spinner {
	font-size: 22px;
}

.check-icon:hover {
	cursor: pointer;
}
.check-icon img {
	width: 20px;
	height: 20px;
}
.tutorial-link {
	font-size: 0.8rem;
	color: #777777;
}
.tutorial-link a {
	color: #777777;
	font-weight: 700;
	text-decoration: none;
}
.tutorial-link a:hover {
	color: #333333;
}
.question-color {
	color: #ebebeb;
}
.tutorial-integracao {
	border-bottom: 1px solid #dddddd;
}
.tutorial-integracao .row {
	border-top: 1px solid #dddddd;
}
.tutorial-integracao .row + .row {
	border-bottom: 1px solid #dddddd;
}
.link-domain {
	color: #000000;
	font-weight: bold;
}
.link-domain:hover {
	text-decoration: none;
}
.remove-domain {
	cursor: pointer;
	color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/DomainsList.vue